{
  "(optional)": "(opcional)",
  "(required)": "(obrigatório)"
}
